<template>
  <v-container fluid class="pa-0">
    <v-layout column>
      <v-flex xs12>
        <v-toolbar flat>
          <v-toolbar-title>Utilizatori</v-toolbar-title>
          <v-divider
            class="mx-2"
            inset
            vertical>
          </v-divider>
          <v-btn icon @click="refresh">
            <v-icon>mdi-refresh</v-icon>
          </v-btn>
          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Cautare"
            single-line
            hide-details>
          </v-text-field>
        </v-toolbar>
      </v-flex>
      <v-flex xs12 style="position: relative; flex-basis: auto">
        <v-data-table
          :headers="headers"
          :items="items"
          class="elevation-1"
          :loading="loading"
          :search="search"
          item-key="_id"
          :expand="expand">
          <template v-slot:items="props">
            <td style="white-space: nowrap">
              <v-btn icon small class="ma-0" @click="_cbRemoveUser(props.item._id)">
                <v-icon small color="error lighten-2">mdi-delete</v-icon>
              </v-btn>
              <v-btn icon small class="ma-0" @click="_cbEditUser(props.item)">
                <v-icon small color="accent lighten-2">mdi-pencil</v-icon>
              </v-btn>
              <v-btn icon small class="ma-0" @click="_cbExpand(props)">
                <v-icon small color="accent lighten-2">mdi-unfold-more-horizontal</v-icon>
              </v-btn>
            </td>
            <td>{{ props.item.username }}</td>
            <td>{{ props.item.email }}</td>
            <td><v-icon small>{{ props.item.admin ? 'mdi-check' : 'mdi-close' }}</v-icon></td>
            <td><v-icon small>{{ props.item.user ? 'mdi-check' : 'mdi-close' }}</v-icon></td>
            <td><v-icon small>{{ props.item.dummy ? 'mdi-check' : 'mdi-close' }}</v-icon></td>
            <td style="text-align: center">
              <v-chip small :color="props.item.color" v-if="props.item.color"></v-chip>
              <template v-else>
                -
              </template>
            </td>
            <td style="white-space: nowrap;">
              <img :src="`${url}/svg/${props.item.username}-done.png?${Date.now()}`" width="12" class="mr-2">
              <img :src="`${url}/svg/${props.item.username}-edited.png?${Date.now()}`" width="12" class="mr-2">
              <img :src="`${url}/svg/${props.item.username}-repozare.png?${Date.now()}`" width="12" class="mr-2">
              <img :src="`${url}/svg/${props.item.username}-logo.png?${Date.now()}`" width="24">
            </td>
            <td style="white-space: nowrap; font-size: .7em">
              <template v-if="props.item.lastMapCenter">
                <a @click="showOnMap(props.item.lastMapCenter, 'Last map center')">
                  <span>lat: {{ props.item.lastMapCenter.lat }}</span>
                  <br>
                  <span>lng: {{ props.item.lastMapCenter.lng }}</span>
                </a>
              </template>
              <template v-else>
                -
              </template>
            </td>
            <td style="white-space: nowrap; font-size: .7em">
              <template v-if="props.item.currentPosition">
                <a @click="showOnMap(props.item.currentPosition, 'Current position')">
                  <span>lat: {{ props.item.currentPosition.lat }}</span>
                  <br>
                  <span>lng: {{ props.item.currentPosition.lng }}</span>
                </a>
              </template>
              <template v-else>
                -
              </template>
            </td>
            <td>{{ props.item.zoom }}</td>
            <td>{{ props.item.mapType }}</td>
            <td>{{ props.item.zoomDetailsPage }}</td>
            <td>{{ props.item.mapTypeDetailsPage }}</td>
            <td>{{ new Date(props.item.createdAt).toLocaleString('ro-RO') }}</td>
            <td>{{ new Date(props.item.updatedAt).toLocaleString('ro-RO') }}</td>
          </template>
          <template v-slot:expand="props">
            <v-card flat style="width: 75vw">
              <v-card-text>
                <v-progress-linear :indeterminate="true" v-if="loadingExpanded" height="4"></v-progress-linear>
                <template v-else>
                  <v-btn color="primary" @click="_cbRequestPoze(props.item._id)" class="ma-4">
                    Request nou pt lista poze aflate in asteptare
                  </v-btn>
                  <v-alert type="info" class="ml-4" :value="true">
                    Daca user-ul nu este live, doar ultimul request primeste raspuns cand user-ul intra in app.+
                    La fel si pt mai multe request-uri trimise in cascada.
                  </v-alert>

                  <br>

                  <v-container fluid grid-list-md>
                    <v-data-iterator
                      :items="expandedData.data"
                      :rows-per-page-items="rowsPerPage"
                      :pagination.sync="expandedPagination"
                      :total-items="expandedDataTotal"
                      content-tag="div"
                      content-class="d-layout"
                      row
                      wrap>
                      <template v-slot:item="props">
                        <v-flex class="ma-2">
                          <v-card>
                            <v-card-title>
                              <h4 style="display: flex; flex-grow: 1; white-space: nowrap">
                                <div>
                                  <v-icon small>mdi-calendar-question</v-icon>
                                  {{ new Date(props.item.createdAt).toLocaleString('ro-RO') }}
                                  <v-divider></v-divider>
                                  <v-icon small>mdi-calendar-account</v-icon>
                                  {{ props.item.response ? new Date(props.item.updatedAt).toLocaleString('ro-RO') : '-' }}
                                </div>
                                <v-spacer></v-spacer>

                                <v-btn small icon @click="deleteRequest(props.item)">
                                  <v-icon small color="error">
                                    mdi-close
                                  </v-icon>
                                </v-btn>
                              </h4>
                            </v-card-title>
                            <v-divider></v-divider>
                            <v-list dense class="lighten-4" :class="{ 'green': props.item.response, 'red': !props.item.response }">
                              <v-list-tile @click="showFilesQueue(props.item)">
                                <v-list-tile-content>Poze:</v-list-tile-content>
                                <v-list-tile-content class="align-end">{{ props.item.response ? props.item.response.files.length : 0 }}</v-list-tile-content>
                              </v-list-tile>
                            </v-list>
                          </v-card>
                        </v-flex>
                      </template>
                    </v-data-iterator>
                  </v-container>
                </template>
              </v-card-text>
            </v-card>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
    <v-btn
      @click.stop="_cbAddUser"
      absolute
      dark
      fab
      bottom
      right
      color="primary"
      style="bottom: 10px">
      <v-icon>mdi-plus</v-icon>
    </v-btn>

    <v-dialog v-model="addUserDialog" persistent max-width="80vw" :transition="false" no-click-animation hide-overlay>
      <v-card flat>
        <v-card-title class="title">Adaugare user</v-card-title>
        <v-card-text>
          <v-form v-model="addUserValid" ref="addUserForm">
            <v-text-field
              v-model="newUser.username"
              label="Username"
              :rules="[rules.required]">
            </v-text-field>
            <v-text-field
              type="email"
              v-model="newUser.email"
              label="Email"
              :rules="[rules.required, rules.email, unique]">
            </v-text-field>
            <v-text-field
              type="password"
              v-model="newUser.password"
              label="Password"
              :rules="[rules.required, rules.min8]">
            </v-text-field>
            <v-text-field
              class="color-input"
              type="color"
              v-model="newUser.color"
              label="Culoare"
              :rules="[rules.required]">
            </v-text-field>
            <v-radio-group v-model="newUser.type" row>
              <v-radio label="Admin" value="admin"></v-radio>
              <v-radio label="User" value="user"></v-radio>
              <v-radio label="Vizitator" value="dummy"></v-radio>
            </v-radio-group>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat color="error" @click="closeAddUserDialog" :disabled="loading">Renunta</v-btn>
          <v-btn flat color="accent" @click="addUser" :loading="loading" :disabled="loading">Adauga user</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="removeUserDialog" persistent max-width="80vw" :transition="false" no-click-animation hide-overlay>
      <v-card flat>
        <v-card-title class="title">Stergere user</v-card-title>
        <v-card-text>
          <v-alert :value="true" type="warning">
            Sunteti sigur(a) ca doriti sa stergeti acest utilizator?
          </v-alert>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat color="error" @click="closeRemoveUserDialog" :disabled="loading">Renunta</v-btn>
          <v-btn flat color="accent" @click="removeUser" :loading="loading" :disabled="loading">Sterge user</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="editUserDialog" persistent max-width="80vw" :transition="false" no-click-animation hide-overlay>
      <v-card flat>
        <v-card-title class="title">Modificare informatii user</v-card-title>
        <v-card-text>
          <v-form v-model="editUserValid" ref="editUserForm">
            <v-text-field
              v-model="selectedUser.username"
              label="Username"
              :rules="[rules.required]">
            </v-text-field>
            <v-text-field
              type="email"
              v-model="selectedUser.email"
              label="Email"
              :rules="[rules.required, rules.email, unique]">
            </v-text-field>
            <v-text-field
              type="password"
              v-model="selectedUser.password"
              label="Password"
              hint="Completati doar daca doriti modificarea parolei existente"
              persistent-hint
              :rules="[rules.min8]">
            </v-text-field>
            <v-text-field
              class="color-input"
              type="color"
              v-model="selectedUser.color"
              label="Culoare"
              :rules="[rules.required]">
            </v-text-field>
            <v-radio-group v-model="selectedUser.type" row>
              <v-radio label="Admin" value="admin"></v-radio>
              <v-radio label="User" value="user"></v-radio>
              <v-radio label="Vizitator" value="dummy"></v-radio>
            </v-radio-group>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat color="error" @click="closeEditUserDialog" :disabled="loading">Renunta</v-btn>
          <v-btn flat color="accent" @click="editUser" :loading="loading" :disabled="loading">Modifica informatii user</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showMap" persistent max-width="80vw" :transition="false" no-click-animation hide-overlay>
      <v-card flat>
        <v-card-title class="title">{{ locationType }}</v-card-title>
        <v-card-text v-if="location" style="height: 50vh">
          <GmapMap
            :center="location"
            :zoom="17"
            :style="{ width: '100%', height: '100%' }"
            ref="map">

            <GmapMarker :position="location" />
          </GmapMap>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat color="error" @click="showMap = false">Inchide</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="filesQueueDialog" persistent max-width="80vw" :transition="false" no-click-animation hide-overlay>
      <v-card flat>
        <v-card-title class="title">Fisiere in asteptare</v-card-title>
        <v-card-text style="height: 50vh; overflow: auto">
          <v-text-field
            v-model="searchQueue"
            append-icon="mdi-search"
            label="Filtreaza"
            single-line
            hide-details
            class="mb-2">
          </v-text-field>
          <v-data-table
            :headers="filesHeaders"
            :items="filesQueue"
            class="elevation-1"
            :search="searchQueue">
            <template v-slot:items="props">
              <td class="text-xs-left">{{ props.item.name }}</td>
              <td class="text-xs-right">{{ prettyBytes(props.item.size) }}</td>
              <td class="text-xs-left">{{ props.item.tip }}</td>
              <td class="text-xs-left">{{ props.item.parent }}</td>
              <td class="text-xs-left">{{ props.item.idObiectiv }}</td>
              <td class="text-xs-right">{{ new Date(props.item.lastModified).toLocaleString('ro-RO') }}</td>
              <td class="text-xs-left">
                <v-icon>{{ props.item.uploaded ? 'mdi-check' : 'mdi-close' }}</v-icon>
              </td>
            </template>
          </v-data-table>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat color="error" @click="filesQueueDialog = false">Inchide</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { gmapApi } from 'vue2-google-maps'
import SERVER_URL from '@/config'
import prettyBytes from 'pretty-bytes'

export default {
  name: 'users',

  data: () => ({
    prettyBytes,
    searchQueue: null,
    filesQueueDialog: false,
    filesQueue: [],
    filesHeaders: [
      { text: 'name', value: 'name' },
      { text: 'size', value: 'size' },
      { text: 'tip', value: 'tip' },
      { text: 'parent', value: 'parent' },
      { text: 'idObiectiv', value: 'idObiectiv' },
      { text: 'lastModified', value: 'lastModified' },
      { text: 'uploaded', value: 'uploaded' }
    ],
    expandedUserId: null,
    rowsPerPage: [10],
    expand: false,
    loadingExpanded: false,
    url: SERVER_URL,
    selectedItem: null,
    headers: [
      { text: 'actiuni', value: 'actions' },
      { text: 'username', value: 'username' },
      { text: 'email', value: 'email' },
      { text: 'admin?', value: 'admin' },
      { text: 'user?', value: 'user' },
      { text: 'vizitator?', value: 'dummy' },
      { text: 'culoare', value: 'color' },
      { text: 'marker', value: 'marker' },
      { text: 'last map center', value: 'lastMapCenter' },
      { text: 'current position', value: 'currentPosition' },
      { text: 'zoom', value: 'zoom' },
      { text: 'map type', value: 'mapType' },
      { text: 'zoom on details page', value: 'zoomDetailsPage' },
      { text: 'map type on details page', value: 'mapTypeDetailsPage' },
      { text: 'adaugat', value: 'createdAt' },
      { text: 'modificat', value: 'updatedAt' }
    ],
    addUserDialog: false,
    addUserValid: true,
    newUser: {
      username: null,
      email: null,
      password: null,
      type: 'user',
      color: '#bf0000'
    },
    rules: {
      required: val => !!val || 'Camp obligatoriu',
      min8: val => (typeof val === 'string' && val.length >= 8) || !val || 'Minim 8 caractere',
      email: value => {
        /* eslint-disable no-useless-escape */
        const re = new RegExp('[a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?')
        return re.test(value) || 'Nu prea arata ca o adresa de email valida...'
      }
    },
    search: null,
    removeUserDialog: false,
    editUserDialog: false,
    selectedUser: {
      _id: null,
      username: null,
      email: null,
      password: null,
      type: null,
      color: null
    },
    editUserValid: true,
    showMap: false,
    location: null,
    locationType: null
  }),

  computed: {
    loading () {
      return this.$store.getters.loading
    },
    items () {
      return this.$store.getters.users
    },
    google: gmapApi,
    expandedData () {
      return this.$store.getters.adminRequestsData
    },
    expandedDataTotal () {
      return this.$store.getters.expandedDataTotal
    },
    expandedPagination: {
      get () {
        return this.$store.getters.expandedPagination
      },
      async set (value) {
        if (this.expandedPagination.page !== value.page) {
          this.loadingExpanded = true
          this.$store.commit('setExpandedPagination', value)
          await this.$store.dispatch('fetchAdminRequests', { _id: this.expandedUserId })
          this.loadingExpanded = false
        }
      }
    }
  },

  methods: {
    deleteRequest (item) {
      this.$store.dispatch('deleteAdminRequest', { id: item._id, user_id: item.user_id })
    },
    showFilesQueue (item) {
      if (item.response) {
        this.filesQueue = item.response.files
        this.filesQueueDialog = true
      }
    },
    _cbRequestPoze (_id) {
      this.$store.dispatch('sendAdminRequest', { _id })
    },
    _cbExpand (props) {
      props.expanded = !props.expanded
      if (props.expanded) {
        this.$store.commit('clearAdminRequestsData')
        this.loadingExpanded = true
        this.expandedUserId = props.item._id
        this.getExpandedData()
      } else {
        this.loadingExpanded = false
        this.$store.commit('clearAdminRequestsData')
        this.expandedUserId = null
        this.$set(this.expandedPagination, 'page', 1)
      }
    },
    async getExpandedData () {
      await this.$store.dispatch('fetchAdminRequests', { _id: this.expandedUserId })
      this.loadingExpanded = false
    },
    unique (val) {
      const user = this.items.find(u => u.email === val)

      if (!user) return true

      if (this.selectedUser._id) {
        return this.selectedUser._id === user._id || 'Email existent in baza de date'
      }

      return !user || 'Email existent in baza de date'
    },
    _cbAddUser () {
      this.addUserDialog = true
    },
    closeAddUserDialog () {
      this.addUserDialog = false
      this.$set(this.newUser, 'username', null)
      this.$set(this.newUser, 'email', null)
      this.$set(this.newUser, 'password', null)
      this.$set(this.newUser, 'type', 'user')
      this.$set(this.newUser, 'color', null)
    },
    addUser () {
      const valid = this.$refs.addUserForm.validate()

      if (valid) {
        const newUser = {
          username: this.newUser.username,
          email: this.newUser.email,
          password: this.newUser.password,
          color: this.newUser.color
        }

        switch (this.newUser.type) {
          case 'user': {
            newUser.user = true
            newUser.dummy = false
            newUser.admin = false
            break
          }
          case 'dummy': {
            newUser.user = false
            newUser.dummy = true
            newUser.admin = false
            break
          }
          case 'admin': {
            newUser.user = false
            newUser.dummy = false
            newUser.admin = true
            break
          }
        }

        this.$store.dispatch('addUser', newUser)

        this.closeAddUserDialog()
      }
    },

    _cbEditUser (user) {
      this.$set(this.selectedUser, '_id', user._id)
      this.$set(this.selectedUser, 'username', user.username)
      this.$set(this.selectedUser, 'email', user.email)
      this.$set(this.selectedUser, 'color', user.color || '#bf0000')

      if (user.admin) this.$set(this.selectedUser, 'type', 'admin')
      else if (user.user) this.$set(this.selectedUser, 'type', 'user')
      else this.$set(this.selectedUser, 'type', 'dummy')

      this.editUserDialog = true
    },
    closeEditUserDialog () {
      this.$set(this.selectedUser, '_id', null)
      this.$set(this.selectedUser, 'username', null)
      this.$set(this.selectedUser, 'email', null)
      this.$set(this.selectedUser, 'password', null)
      this.$set(this.selectedUser, 'type', null)
      this.$set(this.selectedUser, 'color', null)

      this.editUserDialog = false
    },
    editUser () {
      const valid = this.$refs.editUserForm.validate()

      if (valid) {
        const data = {
          email: this.selectedUser.email,
          username: this.selectedUser.username,
          color: this.selectedUser.color
        }

        switch (this.selectedUser.type) {
          case 'admin': {
            data.admin = true
            data.user = false
            data.dummy = false
            break
          }
          case 'user': {
            data.admin = false
            data.user = true
            data.dummy = false
            break
          }
          case 'dummy': {
            data.admin = false
            data.user = false
            data.dummy = true
            break
          }
        }

        if (this.selectedUser.password) data.password = this.selectedUser.password

        this.$store.dispatch('patchUser', { data, id: this.selectedUser._id })

        this.closeEditUserDialog()
      }
    },
    _cbRemoveUser (id) {
      this.removeUserId = id
      this.removeUserDialog = true
    },
    closeRemoveUserDialog () {
      this.removeUserId = null
      this.removeUserDialog = false
    },
    removeUser () {
      this.$store.dispatch('removeUser', this.removeUserId)
      this.closeRemoveUserDialog()
    },
    refresh () {
      this.$store.dispatch('fetchUsers')
    },

    showOnMap (location, type) {
      this.location = location
      this.locationType = type
      this.showMap = true
    },
    closeMap () {
      this.location = null
      this.showMap = false
    }
  },

  mounted () {
    this.$store.dispatch('fetchUsers')
  }
}
</script>
